var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lynus-chart"},[(_vm.chart.customLoader)?_c('ChartLoader'):_vm._e(),_c('div',{ref:"chart",style:(_vm.chartStyles),attrs:{"id":"fullscreen-div"},on:{"click":_vm.chartClickHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }